export default

    class Vehicle {

    constructor(plate = '', doors_qtd = '', gearbox = '', model = '', type_vehicle_id = '', garage_id = null, brand = '', renavam = '1', client_id = null, pre_authorization_value = 1, card_number = '', card_password = null, vehicle_model = {
        model: "",
        url: ""
    }) {
        this.plate = plate
        this.model = model;
        this.vehicle_model = vehicle_model
        this.type_vehicle_id = type_vehicle_id;
        this.garage_id = garage_id;
        this.brand = brand;
        this.renavam = renavam;
        this.client_id = client_id;
        this.pre_authorization_value = pre_authorization_value;
        this.card_number = card_number;
        this.card_password = card_password;
        this.gearbox = gearbox;
        this.doors_qtd = doors_qtd;
    }
}